import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
// Initialise KaTeX globally with mhchem (chemistry) extension before any
// react-katex InlineMath/BlockMath component ever mounts. This ensures the
// \ce{...} macro is recognised everywhere in the app (RenderContent,
// EquationStudio, SectionEquations).
import "katex/dist/katex.min.css";
import "katex/dist/contrib/mhchem.js";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
